import React, { useState } from 'react'

import { redirectToDashboard } from 'helpers/miscellaneous'

import {
    FeedbackFormGifs,
    FeedbackInputForm,
    FeedbackInputWrapper,
    FeedbackInput,
    FeedbackFormWrapper,
    FeedbackFormMasonary,
    Main,
    MainWrapper,
    PageTitle,
    SubmitButton,
    SelectedImage,
    TextCenter,
    Title,
    WrapperImageLeft,
    WrapperImageRight,
} from './styles'

const FeedbackForm = props => {
    const [comments, setComments] = useState('')
    const addFeedback = () => {
        const feedback = {
            feedback_question: props.feedbackQuestion,
            comments,
            room_name: props.roomName,
            gifs: props.selectedGifs.map(item => item.id),
        }
        props.submitFeedback(feedback).then(() => {
            localStorage.removeItem('userId')
            localStorage.removeItem('sessionId')
            localStorage.removeItem('userType')
            localStorage.removeItem('token')
            setTimeout(redirectToDashboard, 1000)
        })
    }

    return (
        <FeedbackFormWrapper>
            <WrapperImageLeft
                src="/img/feedback/leftBg.svg"
                alt="oh"
            ></WrapperImageLeft>
            <WrapperImageRight
                src="/img/feedback/rightBg.svg"
                alt="oh"
            ></WrapperImageRight>
            <Main>
                <MainWrapper>
                    <PageTitle>oh! look what you picked</PageTitle>
                    <FeedbackFormGifs>
                        <FeedbackFormMasonary isFeedbackForm={true}>
                            {props.selectedGifs.map(item => {
                                return (
                                    <SelectedImage
                                        src={item.gif}
                                        key={item.id}
                                    />
                                )
                            })}
                        </FeedbackFormMasonary>
                    </FeedbackFormGifs>
                    <FeedbackInputForm>
                        <TextCenter>
                            <Title>
                                Do you want to tell us something else?
                            </Title>
                        </TextCenter>
                        <FeedbackInputWrapper>
                            <FeedbackInput
                                placeholder="Write here"
                                value={comments}
                                onChange={event =>
                                    setComments(event.target.value)
                                }
                            />
                        </FeedbackInputWrapper>
                    </FeedbackInputForm>
                    <TextCenter>
                        <SubmitButton onClick={addFeedback}>
                            submit
                        </SubmitButton>
                    </TextCenter>
                </MainWrapper>
            </Main>
        </FeedbackFormWrapper>
    )
}

export default FeedbackForm
